import React from "react";

function PageFooter(props) {
    return (
        <section className="page-foot">
            <footer>Version: {process.env.REACT_APP_VERSION}</footer>
        </section>
    );
}

export default PageFooter;
